import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { X, Cookie } from 'lucide-react';
import { Button } from './ui/button';

const STORAGE_KEY = 'cookies_notice_dismissed_v1';

const CookieNotice = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : '1';
    if (!dismissed) {
      const tm = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(tm);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Aviso de cookies"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-[100] animate-in slide-in-from-bottom duration-500"
      data-testid="cookie-notice"
    >
      <div className="bg-white border border-slate-200 rounded-2xl shadow-2xl p-4 md:p-5 flex gap-3">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-amber-400 to-rose-400 flex items-center justify-center text-white">
          <Cookie className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-slate-800 text-sm mb-1">
            {t('cookies.noticeTitle', 'Cookies')}
          </h3>
          <p className="text-xs text-slate-600 leading-relaxed">
            {t('cookies.noticeBody',
              'Utilizamos cookies técnicas necesarias para el funcionamiento de la aplicación, mantener tu sesión y recordar preferencias como el idioma. ')}
            <Link to="/politica-de-cookies" className="text-amber-600 hover:text-amber-700 underline font-medium" data-testid="cookie-notice-learn-more">
              {t('cookies.learnMore', 'Más información')}
            </Link>
            .
          </p>
          <div className="mt-3 flex justify-end">
            <Button onClick={dismiss} size="sm" className="bg-gradient-to-r from-amber-500 to-rose-500 hover:from-amber-600 hover:to-rose-600 text-white" data-testid="cookie-notice-accept">
              {t('cookies.accept', 'Entendido')}
            </Button>
          </div>
        </div>
        <button
          onClick={dismiss}
          className="flex-shrink-0 text-slate-400 hover:text-slate-600 p-1"
          aria-label="Cerrar"
          data-testid="cookie-notice-close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default CookieNotice;
